import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectLoadedAssignmentProjectIds } from '../selectors/assignment.selectors';
import { getProjectAssignments } from '../services/getProjectAssignments';

export const loadAssignmentsForProjects = createAsyncThunk(
  'assignments/loadAssignmentsForProjects',
  async (projectIds, { getState }) => {
    const alreadyLoadedProjectIds = selectLoadedAssignmentProjectIds(
      getState()
    );
    const projectIdsToLoad = projectIds.filter(
      (projectId) => !alreadyLoadedProjectIds.includes(projectId)
    );

    if (projectIdsToLoad.length === 0) {
      return { assignments: [], loadedProjectIds: [] };
    }

    const projectAssignments = await Promise.all(
      projectIdsToLoad.map((id) => getProjectAssignments(id))
    );

    return {
      assignments: projectAssignments.flat(),
      loadedProjectIds: projectIdsToLoad,
    };
  }
);
